import { DynamicFieldData } from "./types";

//name, company, job title, email, phone, web address - and tickbox w/link for GDPR / privacy policy

export const fields: DynamicFieldData[] = [
  {
    fieldName: "name",
    inputType: "text",
    label: "Name",
    defaultValue: "",
    config: {
      required: "Please enter your name"
    }
  },
  {
    fieldName: "company",
    inputType: "text",
    label: "Company",
    defaultValue: "",
    config: {
      required: "Please enter your company name"
    }
  },
  {
    fieldName: "email",
    inputType: "email",
    label: "Email",
    defaultValue: "",
    config: {
      required: "Please enter your email address"
    }
  },
  {
    fieldName: "sign_up",
    inputType: "checkbox",
    label: "Do you have a project now that needs the future of generative media servers?",
    defaultValue: false,
    config: {
      required: "You must agree to this before submitting this form"
    }
  },
  {
    fieldName: "data_protection",
    inputType: "checkbox",
    label: "Data protection",
    comment: `You agree we may collect, maintain, use and disclose your personal information in accordance with our <a href="https://7thsense.one/privacy-policy/" target="_blank">Personal Data & Cookies Policy<a>.`,
    defaultValue: false,
    config: {
      required: "You must agree to this before submitting this form"
    }
  },
];